import { render, staticRenderFns } from "./BotaoAtivarAnexo.vue?vue&type=template&id=22a74241&scoped=true"
import script from "./BotaoAtivarAnexo.vue?vue&type=script&lang=js"
export * from "./BotaoAtivarAnexo.vue?vue&type=script&lang=js"
import style0 from "./BotaoAtivarAnexo.vue?vue&type=style&index=0&id=22a74241&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a74241",
  null
  
)

export default component.exports